module.exports = __webpack_public_path__ + "src/assets/img/logo.2b1bd7df.svg";